import React from 'react'

export default function FreeRounds(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="32px"
      viewBox="0 0 28 32"
      width="28px"
      xmlSpace="preserve"
      {...props}
    >
      <defs id="defs14" />
      <g id="Layer_1" />
      <g id="spin">
        <g id="g7">
          <path
            d="M23.883,6.086l-2.82,2.832C22.953,10.809,24,13.324,24,16c0,5.516-4.484,10-10,10v-2l-4,4l4,4v-2 c7.719,0,14-6.281,14-14C28,12.254,26.539,8.734,23.883,6.086z"
            id="path3"
          />
          <path
            d="M18,4l-4-4v2C6.281,2,0,8.281,0,16c0,3.746,1.461,7.266,4.117,9.914l2.82-2.832 C5.047,21.191,4,18.676,4,16C4,10.484,8.484,6,14,6v2L18,4z"
            id="path5"
          />
        </g>
      </g>
      <g
        aria-label="F"
        id="text1096"
      >
        <path
          d="m 10.194421,11.181818 h 6.362759 v 1.782062 h -4.005047 v 1.702451 h 3.766214 v 1.782063 h -3.766214 v 3.876445 h -2.357712 z"
          id="path2457"
        />
      </g>
    </svg>
  )
}
